export class PasswordExpired extends HTMLElement {
  constructor() {
    super();
    this.valid_regex = false;
  }

  connectedCallback() {
    this.innerHTML =
      `
      <div class="top-content">
        <div class="inner-bg">
          <div class="container">
            <div class="row">
              <div class="col-sm-6 col-sm-offset-3 form-box">
                <div class="form-top">
                  <div class="xn-logo text-center">
                    <!-- <%= image_tag "logo-newco-@2x.png", width:'220', alt: "AutoID logo" %> -->
                  </div>
                  <div class="form-top-left">
                    <p>Change your password</p>
                  </div>
                  <div class="form-top-right hide">
                    <i class="fa fa-lock"></i>
                  </div>
                </div>
                <div class="form-bottom">
                  <form>
                    <div id='error_container'></div>
                    <div class="form-group">
                      <div id="psw_message" class="col-sm-12">
                        <label>Password must contain the following:</label>
                        <p id="number" class="psw_invalid">&nbsp A number</p>
                        <p id="sp_char" class="psw_invalid">&nbsp A special character</p>
                        <p id="length" class="psw_invalid">&nbsp Minimum 8 characters</p>
                      </div>
                      <input type="password" id="password" class="form-password form-control" placeholder="Password">
                    </div>

                    <div class="form-group">
                      <input type="password" id="password_confirmation" class="form-password form-control" placeholder="Password Confirmation">
                    </div>

                    <div class="actions">
                      <button type="submit" class="btn btn-success">Change my password</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      `;

    this.querySelector('#password').onkeyup = () => {this.validate_regex()}
    this.querySelector('button').addEventListener('click', function(e) {
      e.preventDefault();
      this.save();
    }.bind(this))
  }

  validate_regex() {
    let psw_input = this.querySelector('#password');
    let length = this.querySelector('#length');
    let number = this.querySelector('#number');
    let sp_char = this.querySelector('#sp_char');
    let numbers = /[0-9]/g;
    let sp_chars = /[^a-zA-Z0-9]/g;
    this.valid_regex = true;

    if(psw_input.value.match(numbers)) {
      number.classList.remove("psw_invalid");
      number.classList.add("psw_valid");
    } else {
      number.classList.remove("psw_valid");
      number.classList.add("psw_invalid");
      this.valid_regex = false;
    }
    if(psw_input.value.match(sp_chars)) {
      sp_char.classList.remove("psw_invalid");
      sp_char.classList.add("psw_valid");
    } else {
      sp_char.classList.remove("psw_valid");
      sp_char.classList.add("psw_invalid");
      this.valid_regex = false;
    }
    if(psw_input.value.length >= 8) {
      length.classList.remove("psw_invalid");
      length.classList.add("psw_valid");
    } else {
      length.classList.remove("psw_valid");
      length.classList.add("psw_invalid");
    }

    return this.valid_regex
  }

  validate() {
    let is_valid = true;
    let errors = '';
    this.querySelector('#error_container').innerHTML = '';

    if(!this.valid_regex) {
      this.querySelector("#error_container").innerHTML = `<div class="alert alert-danger alert-dismissible" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong>Warning!</strong> Your password must be at least 8 characters and include a number and a special character.
                  </div>`;
      return;
    }
    if(this.querySelector("#password").value.trim() != this.querySelector("#password_confirmation").value.trim()) {
      this.querySelector("#error_container").innerHTML = `<div class="alert alert-danger alert-dismissible" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong>Warning!</strong> Your passwords do not match.
                  </div>`;
      return;
    }

    this.querySelector('#error_container').innerHTML = errors;
    return is_valid
  }

  async save() {
    if(!this.validate() || !this.validate_regex()) {
      return
    }

    let data = {
      password: this.querySelector('#password').value.trim(),
      password_confirmation: this.querySelector('#password_confirmation').value.trim()
    }

    let res = await fetch(`/users/profile/password`, {
      headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                'Content-type': 'application/json'},
      method: 'PUT',
      body: JSON.stringify(data)
    })
    let response = await res.json();
    if(response.success) {
      Common.notify('Password updated.', 'success');
      window.location.href = '/';
    } else if(response.error == "REUSE") {
      this.querySelector("#error_container").innerHTML = `<div class="alert alert-danger alert-dismissible" role="alert">
                          <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                          <strong>Warning!</strong> Password cannot be the same as the old password.
                        </div>`;
    } else {
      Common.notify(`'Unable to update password.'`, 'error');
    }
  }
}

customElements.define('password-expired', PasswordExpired)